import { Stack } from '@mui/system'
import { t } from 'i18next'
import React from 'react'
import { WeekdayButtonInput } from './WeekdayButtonInput'
import { FieldValues, Path } from 'react-hook-form'
import { commonWeekdays } from '../../utils'

interface ChargingCalendarProps<TFieldValues extends FieldValues> {
  calendarIndex: number
  weekdayIndexes?: {
    monday: number | null
    tuesday: number | null
    wednesday: number | null
    thursday: number | null
    friday: number | null
    saturday: number | null
    sunday: number | null
  }
  name: Path<TFieldValues>
  hideDirty?: boolean
}

/** A list of every weekday in a row with an round button for selection */
export const WeekdaySelector = <TFieldValues extends FieldValues>({
  calendarIndex,
  weekdayIndexes,
  name,
  hideDirty = false,
}: ChargingCalendarProps<TFieldValues>): JSX.Element => {
  const isNotSameOrNull = (num: number | null, index: number): boolean => {
    return num !== null && num !== index
  }

  return (
    <Stack sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', flexWrap: 'wrap' }}>
      {commonWeekdays.map(weekday => {
        return (
          <WeekdayButtonInput
            key={`month-${weekday.translationKey}`}
            name={`${name}.${weekday.nameKey}`}
            text={t(weekday.translationKey)}
            disabled={weekdayIndexes && isNotSameOrNull(weekdayIndexes[weekday.nameKey], calendarIndex)}
            hideDirty={hideDirty}
          />
        )
      })}
    </Stack>
  )
}
